import PropTypes from 'prop-types';
import { EDITOR_HEIGHT } from './constants';

export const CODE_EDITOR_PROP_TYPES = {
  options: PropTypes.shape(),
  height: PropTypes.oneOf(Object.values(EDITOR_HEIGHT)),
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  invalid: PropTypes.bool,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onValidate: PropTypes.func,
  onPaste: PropTypes.func,
  onAfterEditorConfigured: PropTypes.func,
};
